<div class="row">
  <!--Container for zonedata-->
  @if (zoneData?.snapshotBase64) {
    <div class="col-lg-12">
      <div class="zoneList">
        <div>
          <h6>{{'ACTIVE_ZONES' |translate}}</h6>
          @for (zone of zoneData?.activeZones; track zone) {
            <div class="alert cursorPointer zoneBlock"
              [ngClass]="getClassForZone(zone)" (click)="editZone(zone)">
              {{zone.name}} <span class="float-right">@if (!zone.modified) {
              <span class="fa-light fa-fw fa-ban disableZone"
              (click)="disableZone(zone)"></span>
              }@if (zone.modified) {
              <span
              class="fa-light fa-lg fa-fw fa-floppy-disk" (click)="saveZone(zone)"></span>
            }
            @if (zone.modified) {
              <span class="fa-light fa-lg fa-fw fa-xmark ml-3"
              (click)="cancelZoneEdit(zone)"></span>
            }
          </span>
        </div>
      }
    </div>
    @if (zoneData?.disabledZones.length > 0) {
      <div>
        <h6>{{'DISABLED_ZONES' |translate}}</h6>
        @for (zone of zoneData?.disabledZones; track zone) {
          <div class="alert zoneBlock"
            [ngClass]="getClassForZone(zone)">
            {{zone.name}} <span class="float-right">@if (!zone.modified) {
            <span
              class="fa-light fa-fw fa-check activateZone cursorPointer"
            (click)="activateZone(zone)"></span>
            }@if (zone.modified) {
            <span
              class="fa-light fa-lg fa-fw fa-floppy-disk cursorPointer"
            (click)="saveZone(zone)"></span>
            }@if (zone.modified) {
            <span
              class="fa-light fa-lg fa-fw fa-xmark ml-3 cursorPointer"
            (click)="cancelZoneEdit(zone)"></span>
          }</span>
        </div>
      }
    </div>
  }
</div>
<div class="zoneContainer" [style.height.px]="zoneData?.height" [style.width.px]="zoneData?.width" #dragBounds>
  @if (zoneData) {
    <img [src]="'data:image/png;base64,' + zoneData.snapshotBase64" />
  }
  <svg [style.height.px]="zoneData?.height" [style.width.px]="zoneData?.width" class="zonesSvg">
    @for (zone of zoneData?.activeZones; track zone) {
      <polygon [attr.points]="zone.coords"
        [ngClass]="getClassForZone(zone)" (click)="editZone(zone)" />
    }
  </svg>
  @for (xy of selectedZone?.xyCoords; track xy; let i = $index) {
    <div class="zonePoint" ngDraggable [bounds]="dragBounds" [inBounds]="true" [preventDefaultEvent]="true"
      (movingOffset)="onMoving($event, i)"
    [ngStyle]="{'left.px': xy.left, 'top.px': xy.top}"></div>
  }
</div>
</div>
}
<!--Error if snapshot could not be loaded-->
@if (!zoneData?.snapshotBase64 && zoneData?.zones.length > 0) {
  <div class="col-lg-4">
    {{'SNAPSHOT_NOT_LOADED' |translate}}
  </div>
}
<!--Loading icon while zone information and snapshot is being loaded-->
@if (!zoneData) {
  <div class="col-lg-12">
    <img class="fadeLoader centerLoader logoSmall" src="assets/img/loading_logo.svg">
  </div>
}
</div>
